import {createFundamentalType, registerFundamentalNode} from "#template/fundamental/factory"
import {BooleanInfo} from "#template/interface-descriptors"
import type {BuilderInlet} from "#template/runtime-graph/graph-builder"
import type {GraphBuilderScope} from "#template/runtime-graph/graph-builder-scope"
import type {NodeEvaluator} from "#template/node-evaluator"
import {isBuilderOutlet} from "#template/runtime-graph/descriptors"
import {ResolveAlias} from "#template/runtime-graph/types"
import {booleanMarker} from "#template/nodes/boolean/marker"
import type {BooleanLike} from "#template/nodes/boolean/marker"

export {booleanLike, booleanLikeMarker, booleanLikeNode, isBooleanLikeNode, isBooleanLikeNodeClass, isBooleanLike} from "#template/nodes/boolean/marker"
export type {BooleanLike, BooleanLikeNode} from "#template/nodes/boolean/marker"

export const BooleanFT = createFundamentalType({
    name: "Boolean",
    marker: booleanMarker,
    InfoClass: BooleanInfo,
    icon: "far fa-square-check",
})

@registerFundamentalNode(BooleanFT, "Likes")
export class BooleanLikes extends BooleanFT.Likes {}

@registerFundamentalNode(BooleanFT, "Switch")
export class BooleanSwitch extends BooleanFT.Switch {}

// BooleanInput resolves immediately to a plain boolean when possible. This matters for tree-filter
// logic (e.g. Group.onFilterActive) that requires an instantly evaluable boolean rather than a
// BuilderInlet.
@registerFundamentalNode(BooleanFT, "Input")
export class BooleanInput extends BooleanFT.Input {
    override evaluate = (scope: GraphBuilderScope, evaluator: NodeEvaluator): BuilderInlet<boolean | null> => {
        const templateInput = this.getTemplateInput(scope, evaluator) ?? evaluator.evaluate((this.parameters.default ?? null) as BooleanLike | null)
        if (templateInput !== undefined && !isBuilderOutlet(templateInput) && !(templateInput instanceof ResolveAlias)) {
            if (typeof templateInput === "object" && templateInput !== null) return templateInput.value
            else return templateInput
        }
        const {templateScope} = evaluator
        return scope.unresolvedToNull(templateScope.resolve<boolean | null>(`templateInputs-${evaluator.getLocalId(this)}`))
    }
}

@registerFundamentalNode(BooleanFT, "Output")
export class BooleanOutput extends BooleanFT.Output {}

@registerFundamentalNode(BooleanFT, "Export")
export class BooleanExport extends BooleanFT.Export {}
